import { Component, OnInit, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PaymentService } from '../_services/payment-service.service';
import { DialogService } from '../_services/dialog.service';

@Component({
  templateUrl: './purchase-details-modal.component.html',
  styleUrls: ['./purchase-details-modal.component.css']
})
export class PurchaseDetailsModalComponent implements OnInit {

  public loading = false;
  public purchaseDetails = [];

  constructor(
    private bsModalRef: BsModalRef,
    private paymentService: PaymentService
    ) { }

    purchase: any;

    @Output() updateOnClose = new EventEmitter();

  close() {
    this.bsModalRef.hide();
  }

  ngOnInit() {
    this.loading = true;

    this.paymentService.getPurchaseDetails(this.purchase.purchaseId).subscribe(data => {
      this.purchaseDetails = data;
      this.loading = false;
    });
  }
}

